module.exports = __webpack_public_path__ + "static/media/steak.bd08b042.svg";